<template>
<div v-if="done" class="submit-event flex">
  <div class="group half">
    <h3>Success!</h3>
    <p>Thanks for submitting your community event</p>
    <button type="button" class="button button-outline"
      @click="closePopup()">
        Close
    </button>
  </div>
</div>
<div v-else class="submit-event flex" :class="{'dirty':dirty}">
  <div class="half group">
    <input required type="text" v-model="event.yourName">
    <label>Your Name</label>
  </div>

  <div class="half group">
    <input required type="text" v-model="event.schoolDepartment">
    <label>Location of Event</label>
  </div>
  
  <div class="half group">
    <input required type="text" v-model="event.contactInfo">
    <label>Your Contact Info</label>
  </div>

  <div class="half flex">
    <div class="group third">
      <select required v-model="event.month">
        <option>January</option>
        <option>February</option>
        <option>March</option>
        <option>April</option>
        <option>May</option>
        <option>June</option>
        <option>July</option>
        <option>August</option>
        <option>September</option>
        <option>October</option>
        <option>November</option>
        <option>December</option>
      </select>
      <label>Month</label>
    </div>

    <div class="group third">
      <input required type="text" v-model="event.day">
      <label>Day</label>
    </div>

    <div class="group third">
      <input required type="text" v-model="event.time">
      <label>Time</label>
    </div>
  </div>

  <div class="full group">
    <input required type="text" v-model="event.name">
    <label>Event Name</label>
  </div>

  <div class="group full">
    <textarea required type="text" v-model="event.description"></textarea>
    <label>Brief Description of Event</label>
  </div>

  <p class="group two third" :class='msgStatus'>{{msg}}</p>
  <div class="group third">
    <button type="button" v-if="status === false" class="button button-block" @click="submitEvent($event)">Submit Event</button>
    <button type="button" v-if="status === true" class="button button-outline button-block">Submitting...</button>
  </div>
</div>
</template>

<script>
import moment from 'moment'

function filledOut() {
  for(let i = arguments.length - 1; i >= 0; i--) {
    if(arguments[i] == null || arguments[i] == '') return false
  }
  return true;
}

export default {
  data() {
    return {
      dirty: false,
      status: false,
      done: false,
      event: {
        yourName: '',
        schoolDepartment: '',
        name: '',
        date: '',
        month: '',
        day: '',
        time: '',
        description: ''
      },
      msg: '',
      msgStatus: ''
    }
  },
  methods: {
    closePopup() {
      try {
        document.querySelector('a.submitevent').click()
      } catch (e) { }
    },
    submitEvent: function(ev) {
      this.status = true
      this.dirty = true

      let e = this.event;
      if(filledOut(e.yourName, e.schoolDepartment, e.name, e.month, e.day, e.time, e.description)) {
        let now = moment()
        let year = moment().format('YYYY')
        if(moment(e.month, 'MMMM').diff(now, 'months') < 0) {
          year = (parseInt(year) + 1).toString()
        }

        let _time = e.time.split(/(to|-)/)[0].trim()

        e.date = moment(`${e.month} ${e.day} ${year} ${_time}`,
          ['MMMM-D-YYYY h:mma', 'MMMM-D-YYYY ha', 'MMMM-D-YYYY H']
        ).toISOString()
        if(e.date == null) {
          e.date = now.toISOString()
          e.description += `\n${e.month} ${e.day} ${year} ${e.time}`
        }
        this.msg = ""

        fetch('/api/community/event', {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: "POST",
          body: JSON.stringify(e)
        }).then(res => res.json())
        .then(data => {
          this.msg = data.success ? "Success" : "Error submitting event"
          this.status = false
          this.done = data.success
        }).catch(e => {
          this.msg = e
          this.status = false
        })
      } else {
        this.msg = "Please fill out all of the fields before submitting."
        this.status = false
      }

      console.info('submit event', event, this.event, this.status)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../styles/variables.less";

.group {
  position: relative;
  margin: 1em;
  @media(min-width: @width-tablet) {
    margin: unset;
  }

  input, textarea, select {
    height: unset;
    padding: 1.6rem 0.8rem 0.2em;
    font-size: 1.7rem;
    border-radius: 0;
    border-width: 2px;
    border-color: #ccd;
    margin-bottom: 0;
  }
  textarea {
    resize: vertical;
    min-height: 8.5em;
  }

  input:focus ~ label, input:valid ~ label,
  textarea:focus ~ label, textarea:valid ~ label,
  select:focus ~ label, select:valid ~ label {
    font-size: 0.9rem;
    top: 0.4rem;
    opacity: 0.75;
  }

  label {
    opacity: 0.6;
    transition: all 0.1s ease;
    position: absolute;
    top: 0.9rem;
    left: 1rem;
    font-weight: normal;
    pointer-events: none;
  }
}

.dirty {
  input:invalid, textarea:invalid, select:invalid {
    border-color: red;
  }
}

@media(min-width: @width-tablet) {
  .flex {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
  }
  .half { width: 49%; }
  .third { width: 33%; }
  .two.third { width: 65%; }
  .full { width: 100%; }
}
</style>

<style lang="less">
@import "../styles/variables.less";
.popup .submit-event {
  margin-top: 1em;
  padding: 1em;

  @media(min-width: @width-tablet) {
    margin-top: unset;
    position: absolute;
    top: 3.6em;
    width: 730px;
    height: 395px;
    z-index: 99;
    background: rgba(255,255,255,0.95);
    padding: 2em 2em 0;
    right: 1.5em;
  }
}
</style>



// WEBPACK FOOTER //
// theme/_base/vue/SubmitEvent.vue